import { useState } from "react";
import { config } from "../../../../../utils/config";
import { useErrorPixData, useDownloadErrorPixMutation } from "./use-error-pix-queries";

interface ErrorPixToastState {
  open: boolean;
  message: string;
  variant: "default" | "destructive" | "success";
}

export function useErrorPix() {
  const selectedFund = `xama_${config.stage}`;
  const [toast, setToast] = useState<ErrorPixToastState>({
    open: false,
    message: "",
    variant: "default",
  });

  const { data: errorPixData, isLoading, refetch } = useErrorPixData(selectedFund);
  const downloadMutation = useDownloadErrorPixMutation();



  const handleDownloadRequest = async () => {
    if (!selectedFund) return;

    try {
      await downloadMutation.mutateAsync(selectedFund);

      setToast({
        open: true,
        message: "✅ Solicitação de arquivos de pagamento enviada com sucesso!",
        variant: "success",
      });
    } catch (error) {
      setToast({
        open: true,
        message: "❌ Erro ao solicitar arquivos de pagamento. Por favor, tente novamente.",
        variant: "destructive",
      });
    }
  };

  const closeToast = () => {
    setToast({ ...toast, open: false });
  };

  const showToast = (
    message: string,
    variant: ErrorPixToastState["variant"] = "default"
  ) => {
    setToast({ open: true, message, variant });
  };

  return {
    selectedFund,
    errorPixData: errorPixData?.errorPix || [],
    isLoading: isLoading || downloadMutation.isPending,
    toast,

    handleDownloadRequest,
    closeToast,
    showToast,
    refetch,
  };
}
